<template>
  <div class="page_content">
    <div class="row">
      <div class="col-md-4">
        <generated-wages-employee
          searchType="generated_wages_employee"
          ref="search"
          @searchEmployeeInGeneratedWagesList="
            searchEmployeeInGeneratedWagesList
          "
          @reset_search="reset_search"
        />
      </div>
      <div class="col-md-8">
        <div class="float-right">
          <button
            @click="close_wages"
            v-if="has_open_records"
            class="site_btn btn_danger m-r-10"
          >
            {{ $t('wages_module.closeallwages') }}
          </button>
          <button
            class="site_btn btn_export m-r-10"
            @click="openTaxDeclarationModal"
          >
            {{ $t('wages_module.taxdeclaration') }}
          </button>
          <button
            v-if="!has_open_records"
            class="site_btn btn_blue m-r-10"
            @click="openGenerateSalary"
          >
            {{ $t('wages_module.generatewages') }}
          </button>
          <button
            v-if="has_open_records"
            class="site_btn btn_danger m-r-10"
            @click="deleteGeneratedSalaries"
          >
            {{ $t('wages_module.deletegeneratedwages') }}
          </button>
          <button
            @click="export_modal = true"
            class="site_btn btn_export m-r-10"
          >
            {{ $t('wages_module.export') }}
          </button>
          <button
            v-if="filtered"
            class="site_btn btn_purple"
            @click="clearFilters"
          >
            {{ $t('wages_module.clearfilter') }}
          </button>
          <button
            v-if="!filtered"
            class="site_btn btn_purple"
            @click="openFilters"
          >
            {{ $t('wages_module.filter') }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="component_loading" class="widget_listings">
      <div class="component_loader">
        <spinner :status="component_loading" />
      </div>
    </div>
    <div v-else>
      <div v-if="visibleGeneratedSalaries.length > 0">
        <div
          v-for="generated_salary_item in visibleGeneratedSalaries"
          :key="generated_salary_item.monthly_salary_id"
        >
          <div class="boxi m-t-20">
            <div class="row">
              <div class="col-md-3">
                <div class="row">
                  <div class="col-2">
                    <template
                      v-if="
                        generated_salary_item.image_url == '' ||
                        generated_salary_item.image_url == null ||
                        generated_salary_item.image_url == undefined
                      "
                    >
                      <img
                        src="/images/user/no-image.png"
                        class="imgCandidate"
                      />
                    </template>
                    <template v-else>
                      <img
                        :src="
                          SERVER_URL +
                          IMAGES_FILES +
                          generated_salary_item.image_url
                        "
                        class="imgCandidate"
                      />
                    </template>
                  </div>
                  <div class="col-10">
                    <div class="textinBoxCandidateDetails">
                      <h4>
                        {{ generated_salary_item.name }}
                        {{ generated_salary_item.surname }}
                      </h4>
                      <h5>{{ generated_salary_item.position }}</h5>
                      <h5>{{ generated_salary_item.department }}</h5>
                    </div>
                    <template v-if="generated_salary_item.is_termination_pay">
                      <span class="badge badge-danger ml-3">{{
                        $t('salary_page.terminationpay')
                      }}</span>
                    </template>
                    <p class="mb-0 m-t-10 text-muted">
                      {{ $t('employee_module.paymentcurrency') }}:
                      {{ getSourceCurrencyLabel(generated_salary_item) }}
                    </p>
                    <p class="mb-0 text-muted">
                      {{ $t('payroll_currency.shown_in') }}:
                      {{ getDisplayedCurrencyCode(generated_salary_item) }}
                    </p>
                    <p
                      v-if="isCurrencyConverted(generated_salary_item)"
                      class="mb-0 text-muted"
                    >
                      {{ $t('payroll_currency.conversion_rate') }}:
                      {{ formatConversionRate(generated_salary_item) }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-6" />
              <div class="col-md-3">
                <div class="wages_list_details text-center">
                  <p>{{ $t('wages_module.salaryfor') }}</p>
                  <h4>
                    {{ $t('monthsvalue.' + generated_salary_item.month) }}
                    {{ generated_salary_item.year }}
                  </h4>
                </div>
                <template v-if="generated_salary_item.closed === 0">
                  <template
                    v-if="
                      actions &&
                      actionId === generated_salary_item.monthly_salary_id
                    "
                  >
                    <img
                      src="/images/hrbeeElements/companyIcons/actionsVerticalActive.svg"
                      @click="cancelActions()"
                      class="actionIcon"
                    />
                  </template>
                  <template v-else>
                    <img
                      src="/images/hrbeeElements/companyIcons/actionsVertical.svg"
                      @click="
                        openactions(generated_salary_item.monthly_salary_id)
                      "
                      class="actionIcon"
                    />
                  </template>
                </template>
              </div>
            </div>
            <hr />

            <div class="d-flex justify-content-between">
              <div class="wages_list_details text-center px-1">
                <p class="mb-2">{{ $t('wages_module.rankofjob') }}</p>
                <h4
                  v-if="
                    supportsSecondJob &&
                    generated_salary_item.is_second_job == 0
                  "
                >
                  {{ $t('salary_page.primaryjob') }}
                </h4>
                <h4
                  v-if="
                    supportsSecondJob &&
                    generated_salary_item.is_second_job == 1
                  "
                >
                  {{ $t('salary_page.secondaryjob') }}
                </h4>
                <h4 v-if="!supportsSecondJob">-</h4>
              </div>
              <div class="wages_list_details text-center px-1">
                <p class="mb-2">
                  {{
                    parseFloat(generated_salary_item.working_hours) > 0
                      ? $t('wages_module.grosssalaryByHours')
                      : $t('wages_module.grosssalary')
                  }}
                </p>
                <h4>
                  {{
                    parseFloat(generated_salary_item.working_hours) > 0
                      ? formatPayrollAmount(
                          generated_salary_item.gross_salary_by_hours,
                          generated_salary_item
                        )
                      : formatPayrollAmount(
                          generated_salary_item.gross_salary,
                          generated_salary_item
                        )
                  }}
                  {{ getDisplayedCurrencyCode(generated_salary_item) }}
                </h4>
              </div>
              <div class="wages_list_details text-center px-1">
                <p class="mb-2">{{ $t('wages_module.grosssalarybonus') }}</p>
                <h4>
                  {{
                    formatPayrollAmount(
                      generated_salary_item.bonus_payment,
                      generated_salary_item
                    )
                  }}
                  {{ getDisplayedCurrencyCode(generated_salary_item) }}
                </h4>
              </div>
              <div class="wages_list_details text-center px-1">
                <p class="mb-2">{{ $t('wages_module.grosssalarytotal') }}</p>
                <h4>
                  {{
                    parseFloat(generated_salary_item.working_hours) > 0
                      ? formatPayrollAmount(
                          parseFloat(
                            generated_salary_item.gross_salary_by_hours
                          ) + parseFloat(generated_salary_item.bonus_payment),
                          generated_salary_item
                        )
                      : formatPayrollAmount(
                          parseFloat(generated_salary_item.gross_salary) +
                            parseFloat(generated_salary_item.bonus_payment),
                          generated_salary_item
                        )
                  }}
                  {{ getDisplayedCurrencyCode(generated_salary_item) }}
                </h4>
              </div>
              <div class="wages_list_details text-center px-1">
                <p class="mb-2 blue">{{ $t('wages_module.contribution') }}</p>
                <h4 v-if="generated_salary_item.pay_contribution == 0">
                  {{ $t('common.no') }}
                </h4>
                <h4 v-if="generated_salary_item.pay_contribution == 1">
                  {{ $t('common.yes') }}
                </h4>
              </div>
              <div class="wages_list_details text-center px-1">
                <p class="mb-2 green">{{ $t('employee_module.taxes') }}</p>
                <h4 v-if="generated_salary_item.pay_tax == 0">
                  {{ $t('common.no') }}
                </h4>
                <h4 v-if="generated_salary_item.pay_tax == 1">
                  {{ $t('common.yes') }}
                </h4>
              </div>
              <div class="wages_list_details text-center px-1">
                <p class="mb-2 red">
                  {{ $t('wages_module.healthinsurancecost') }}
                </p>
                <h4 class="pt-1">
                  {{
                    parseFloat(generated_salary_item.health_insurance_cost) > 0
                      ? formatPayrollAmount(
                          generated_salary_item.health_insurance_gross,
                          generated_salary_item
                        )
                      : formatPayrollAmount(
                          generated_salary_item.health_insurance_cost,
                          generated_salary_item
                        )
                  }}
                  {{ getDisplayedCurrencyCode(generated_salary_item) }}
                </h4>
              </div>
            </div>

            <div class="d-flex justify-content-between">
              <div
                v-if="showPayrollField('tax_0_to_80_0_percent')"
                class="wages_list_details text-center"
              >
                <p class="mb-2">
                  {{ getPayrollLabel('tax_0_to_80_0_percent') }}
                </p>
                <h4
                  v-if="
                    parseFloat(generated_salary_item.health_insurance_cost) > 0
                  "
                >
                  {{
                    formatPayrollAmount(
                      generated_salary_item.tax_0_to_80_0_percent_with_health_insurance,
                      generated_salary_item
                    )
                  }}
                  {{ getDisplayedCurrencyCode(generated_salary_item) }}
                </h4>
                <h4 v-else>
                  {{
                    formatPayrollAmount(
                      generated_salary_item.tax_0_to_80_0_percent,
                      generated_salary_item
                    )
                  }}
                  {{ getDisplayedCurrencyCode(generated_salary_item) }}
                </h4>
              </div>
              <div
                v-if="showPayrollField('tax_80_to_250_4_percent')"
                class="wages_list_details text-center"
              >
                <p class="mb-2">
                  {{ getPayrollLabel('tax_80_to_250_4_percent') }}
                </p>
                <h4
                  v-if="
                    parseFloat(generated_salary_item.health_insurance_cost) > 0
                  "
                >
                  {{
                    formatPayrollAmount(
                      generated_salary_item.tax_80_to_250_4_percent_with_health_insurance,
                      generated_salary_item
                    )
                  }}
                  {{ getDisplayedCurrencyCode(generated_salary_item) }}
                </h4>
                <h4 v-else>
                  {{
                    formatPayrollAmount(
                      generated_salary_item.tax_80_to_250_4_percent,
                      generated_salary_item
                    )
                  }}
                  {{ getDisplayedCurrencyCode(generated_salary_item) }}
                </h4>
              </div>
              <div
                v-if="showPayrollField('tax_250_to_450_8_percent')"
                class="wages_list_details text-center"
              >
                <p class="mb-2">
                  {{ getPayrollLabel('tax_250_to_450_8_percent') }}
                </p>
                <h4
                  v-if="
                    parseFloat(generated_salary_item.health_insurance_cost) > 0
                  "
                >
                  {{
                    formatPayrollAmount(
                      generated_salary_item.tax_250_to_450_8_percent_with_health_insurance,
                      generated_salary_item
                    )
                  }}
                  {{ getDisplayedCurrencyCode(generated_salary_item) }}
                </h4>
                <h4 v-else>
                  {{
                    formatPayrollAmount(
                      generated_salary_item.tax_250_to_450_8_percent,
                      generated_salary_item
                    )
                  }}
                  {{ getDisplayedCurrencyCode(generated_salary_item) }}
                </h4>
              </div>
              <div
                v-if="showPayrollField('tax_greater_450_10_percent')"
                class="wages_list_details text-center"
              >
                <p class="mb-2">
                  {{ getPayrollLabel('tax_greater_450_10_percent') }}
                </p>
                <h4
                  v-if="
                    parseFloat(generated_salary_item.health_insurance_cost) > 0
                  "
                >
                  {{
                    formatPayrollAmount(
                      generated_salary_item.tax_greater_450_10_percent_with_health_insurance,
                      generated_salary_item
                    )
                  }}
                  {{ getDisplayedCurrencyCode(generated_salary_item) }}
                </h4>
                <h4 v-else>
                  {{
                    formatPayrollAmount(
                      generated_salary_item.tax_greater_450_10_percent,
                      generated_salary_item
                    )
                  }}
                  {{ getDisplayedCurrencyCode(generated_salary_item) }}
                </h4>
              </div>
              <div class="wages_list_details text-center">
                <p class="mb-2 blue">
                  {{ getPayrollLabel('contribution_5_percent') }}
                </p>
                <h4
                  v-if="
                    parseFloat(generated_salary_item.health_insurance_cost) > 0
                  "
                >
                  {{
                    formatPayrollAmount(
                      generated_salary_item.contribution_5_percent_with_health_insurance,
                      generated_salary_item
                    )
                  }}
                  {{ getDisplayedCurrencyCode(generated_salary_item) }}
                </h4>
                <h4 v-else>
                  {{
                    formatPayrollAmount(
                      generated_salary_item.contribution_5_percent,
                      generated_salary_item
                    )
                  }}
                  {{ getDisplayedCurrencyCode(generated_salary_item) }}
                </h4>
              </div>
              <div class="wages_list_details text-center">
                <p class="mb-2 green">{{ $t('wages_module.totaltax') }}</p>
                <h4
                  v-if="
                    parseFloat(generated_salary_item.health_insurance_cost) > 0
                  "
                >
                  {{
                    formatPayrollAmount(
                      generated_salary_item.total_tax_with_health_insurance,
                      generated_salary_item
                    )
                  }}
                  {{ getDisplayedCurrencyCode(generated_salary_item) }}
                </h4>
                <h4 v-else>
                  {{
                    formatPayrollAmount(
                      generated_salary_item.total_tax,
                      generated_salary_item
                    )
                  }}
                  {{ getDisplayedCurrencyCode(generated_salary_item) }}
                </h4>
              </div>
              <div class="wages_list_details text-center">
                <p class="mb-2 green">
                  {{ $t('wages_module.absencededuction') }}
                </p>
                <h4
                  v-if="
                    parseFloat(generated_salary_item.health_insurance_cost) > 0
                  "
                >
                  {{
                    formatPayrollAmount(
                      generated_salary_item.absence_deduction,
                      generated_salary_item
                    )
                  }}
                  {{ getDisplayedCurrencyCode(generated_salary_item) }}
                </h4>
                <h4 v-else>
                  {{
                    formatPayrollAmount(
                      generated_salary_item.absence_deduction,
                      generated_salary_item
                    )
                  }}
                  {{ getDisplayedCurrencyCode(generated_salary_item) }}
                </h4>
              </div>
              <div class="wages_list_details text-center">
                <p class="mb-2 green">
                  {{ $t('wages_module.leavededuction') }}
                </p>
                <h4
                  v-if="
                    parseFloat(generated_salary_item.health_insurance_cost) > 0
                  "
                >
                  {{
                    formatPayrollAmount(
                      generated_salary_item.leave_without_payment,
                      generated_salary_item
                    )
                  }}
                  {{ getDisplayedCurrencyCode(generated_salary_item) }}
                </h4>
                <h4 v-else>
                  {{
                    formatPayrollAmount(
                      generated_salary_item.leave_without_payment,
                      generated_salary_item
                    )
                  }}
                  {{ getDisplayedCurrencyCode(generated_salary_item) }}
                </h4>
              </div>
              <div class="wages_list_details text-center">
                <p class="mb-2">{{ $t('wages_module.totalsalary') }}</p>
                <h4 class="f-w">
                  {{
                    formatPayrollAmount(
                      generated_salary_item.total_salary,
                      generated_salary_item
                    )
                  }}
                  {{ getDisplayedCurrencyCode(generated_salary_item) }}
                </h4>
              </div>
              <div class="wages_list_details text-center">
                <p class="mb-2 red">
                  {{ $t('wages_module.healthinsurancecostneto') }}
                </p>
                <h4>
                  {{
                    formatPayrollAmount(
                      generated_salary_item.health_insurance_cost,
                      generated_salary_item
                    )
                  }}
                  {{ getDisplayedCurrencyCode(generated_salary_item) }}
                </h4>
              </div>
              <div class="wages_list_details text-center">
                <p class="mb-2">{{ $t('wages_module.netsalary') }}</p>
                <h4>
                  {{
                    formatPayrollAmount(
                      generated_salary_item.net_salary_with_health_insurance,
                      generated_salary_item
                    )
                  }}
                  {{ getDisplayedCurrencyCode(generated_salary_item) }}
                </h4>
              </div>
            </div>

            <template
              v-if="
                actions && actionId === generated_salary_item.monthly_salary_id
              "
            >
              <hr />
              <ul class="actions-ul">
                <li>
                  <button
                    @click="
                      openModalEdit(generated_salary_item.monthly_salary_id)
                    "
                  >
                    {{ $t('wages_module.edit') }}
                  </button>
                  <button
                    @click="
                      deleteMonthlyReport(
                        generated_salary_item.monthly_salary_id
                      )
                    "
                  >
                    {{ $t('wages_module.delete') }}
                  </button>
                </li>
              </ul>
            </template>
          </div>
        </div>
        <b-pagination
          v-if="
            company_monthly_generated_salary_list.data.length >
            company_monthly_generated_salary_list.total
          "
          align="center"
          class="m-t-20"
          @change="loadAnotherPage"
          :total-rows="company_monthly_generated_salary_list.total"
          v-model="company_monthly_generated_salary_list.current_page"
          :per-page="company_monthly_generated_salary_list.per_page"
        />
      </div>
      <div v-else>
        <div class="boxi m-t-20">
          <div class="textinBox">
            <h4 class="text-center">
              {{ $t('wages_module.nowagesgenerated') }}
            </h4>
          </div>
        </div>
      </div>
    </div>

    <div class="profile_edit_modals" v-if="filtermodal">
      <div class="modal_item">
        <div class="box">
          <div class="close_modal" @click="filtermodal = false">
            <img src="/images/close.svg" width="20px" />
          </div>
          <div class="container m-t-b">
            <div class="addExperienceSection">
              <h4>
                {{ $t('wages_module.filterwages') }}
              </h4>
              <hr />
              <form class="form-type-1" @submit.prevent="filterbymonth">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form__group">
                      <label for="selected_year" class="form__label bold"
                        >{{ $t('wages_module.selectyear') }}
                        <span class="required">(*)</span></label
                      >
                      <multiselect
                        v-validate="'required'"
                        id="selected_year"
                        name="selected_year"
                        v-model="selected_year"
                        :options="selected_yearOptions"
                        placeholder="Select year"
                        label="name"
                        track-by="value"
                      />
                      <span
                        v-show="errors.has('selected_year')"
                        class="form-error-notification error"
                      >
                        {{ $t('inputError.required') }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form__group">
                      <label for="selected_month" class="form__label bold"
                        >{{ $t('wages_module.selectmonth') }}
                        <span class="required">(*)</span></label
                      >
                      <multiselect
                        v-validate="'required'"
                        id="selected_month"
                        name="selected_month"
                        v-model="selected_month"
                        :options="selected_monthOptions"
                        placeholder="Select month"
                        label="name"
                        track-by="value"
                      />
                      <span
                        v-show="errors.has('selected_month')"
                        class="form-error-notification error"
                      >
                        {{ $t('inputError.required') }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="text-center">
                      <button type="submit" class="site_btn btn_purple">
                        {{ $t('wages_module.filter') }}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="profile_edit_modals" v-if="modal">
      <div class="modal_item">
        <div class="box">
          <div class="close_modal" @click="modal = false">
            <img src="/images/close.svg" width="20px" />
          </div>
          <div class="container m-t-b">
            <div class="addExperienceSection">
              <h4>
                {{ $t('wages_module.generatemonthly') }}
              </h4>
              <hr />
              <form class="form-type-1" @submit.prevent="generateAllWages">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form__group">
                      <label for="selected_year" class="form__label bold"
                        >{{ $t('wages_module.selectyear') }}
                        <span class="required">(*)</span></label
                      >
                      <multiselect
                        v-validate="'required'"
                        id="selected_year"
                        name="selected_year"
                        v-model="generate_wages_selected_year"
                        :options="generate_wages_year_options"
                        placeholder="Select year"
                        label="name"
                        track-by="value"
                        @input="onGenerateWagesYearSelect"
                      />
                      <span
                        v-show="errors.has('selected_year')"
                        class="form-error-notification error"
                      >
                        {{ $t('inputError.required') }}
                      </span>
                    </div>
                  </div>
                  <div
                    class="col-md-6"
                    v-if="
                      generate_wages_selected_year &&
                      generate_wages_selected_year.value
                    "
                  >
                    <div class="form__group">
                      <label for="selected_month" class="form__label bold"
                        >{{ $t('wages_module.selectmonth') }}
                        <span class="required">(*)</span></label
                      >
                      <multiselect
                        v-validate="'required'"
                        id="selected_month"
                        name="selected_month"
                        v-model="generate_wages_selected_month"
                        :options="generate_wages_month_options"
                        placeholder="Select month"
                        label="name"
                        track-by="value"
                      />
                      <span
                        v-show="errors.has('selected_month')"
                        class="form-error-notification error"
                      >
                        {{ $t('inputError.required') }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="text-center">
                      <button type="submit" class="site_btn btn_blue">
                        {{ $t('wages_module.generatewages') }}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="profile_edit_modals" v-if="edit_modal">
      <div class="modal_item">
        <div class="box">
          <div class="close_modal" @click="edit_modal = false">
            <img src="/images/close.svg" width="20px" />
          </div>
          <div class="container m-t-b">
            <div class="addExperienceSection">
              <h4>
                {{ $t('wages_module.editwages') }}
              </h4>
              <hr />
              <form class="form-type-1" @submit.prevent="updateWage">
                <div class="row">
                  <div class="col">
                    <div class="form__group">
                      <label class="form__label bold"
                        >Select year <span class="required">(*)</span></label
                      >
                      <input
                        disabled
                        type="text"
                        class="form__input"
                        name="edit_year"
                        id="edit_year"
                        :value="edit_year"
                      />
                    </div>
                  </div>
                  <div class="col">
                    <div class="form__group">
                      <label class="form__label bold"
                        >Select month <span class="required">(*)</span></label
                      >
                      <input
                        disabled
                        type="text"
                        class="form__input"
                        name="edit_month"
                        id="edit_month"
                        :value="$t('monthsvalue.' + edit_month)"
                      />
                    </div>
                  </div>
                  <div class="col">
                    <div class="form__group">
                      <label class="form__label bold"
                        >Gross salary <span class="required">(*)</span></label
                      >
                      <input
                        disabled
                        type="text"
                        class="form__input"
                        name="edit_gross_salary"
                        id="edit_gross_salary"
                        :value="edit_gross_salary"
                      />
                    </div>
                  </div>
                  <div class="col">
                    <div class="form__group">
                      <label class="form__label bold"
                        >Job rank <span class="required">(*)</span></label
                      >
                      <input
                        disabled
                        type="text"
                        class="form__input"
                        name="edit_job_rank"
                        id="edit_job_rank"
                        :value="
                          edit_job_rank == 1 ? 'Secondary job' : 'Primary job'
                        "
                      />
                    </div>
                  </div>
                  <!-- <div class="col">
                                        <div class="form__group">
                                            <label class="form__label bold">Health insurance <span class="required">(*)</span></label>
                                            <input disabled type="text" class="form__input" name="edit_job_rank" id="edit_job_rank" :value="edit_health_insurance_cost" />
                                        </div>
                                    </div> -->
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <div class="form__group">
                      <label class="form__label bold"
                        >{{ $t('wages_module.advancepayment') }}
                        <span class="required">(*)</span></label
                      >
                      <input
                        type="text"
                        class="form__input"
                        name="edit_advance_payment"
                        id="edit_advance_payment"
                        v-model="edit_advance_payment"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form__group">
                      <label class="form__label bold"
                        >{{ $t('wages_module.leavewithoutpayment') }}
                        <span class="required">(*)</span></label
                      >
                      <input
                        type="text"
                        class="form__input"
                        name="edit_leave_without_payment"
                        id="edit_leave_without_payment"
                        v-model="edit_leave_without_payment"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form__group">
                      <label class="form__label bold"
                        >{{ $t('wages_module.bonuspayment') }}
                        <span class="required">(*)</span></label
                      >
                      <input
                        type="text"
                        class="form__input"
                        name="edit_bonus_payment"
                        id="edit_bonus_payment"
                        v-model="edit_bonus_payment"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form__group">
                      <label class="form__label bold"
                        >Pension deduction
                        <span class="required">(*)</span></label
                      >
                      <input
                        type="text"
                        class="form__input"
                        name="edit_pension_deduction"
                        id="edit_pension_deduction"
                        v-model="edit_pension_deduction"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form__group">
                      <label class="form__label bold"
                        >{{ $t('wages_module.mealspayment') }}
                        <span class="required">(*)</span></label
                      >
                      <input
                        type="text"
                        class="form__input"
                        name="edit_meals_payment"
                        id="edit_meals_payment"
                        v-model="edit_meals_payment"
                      />
                    </div>
                  </div>
                </div>
                <div class="">
                  <b-form-checkbox v-model="workinghours" @change="toggleTerms">
                    <h4>{{ $t('wages_module.workinghours') }}</h4>
                  </b-form-checkbox>
                </div>
                <template v-if="workinghours">
                  <div class="row">
                    <div class="col-md-3">
                      <div class="form__group">
                        <label class="form__label bold"
                          >{{ $t('wages_module.workhourspermonth') }}
                          <span class="required">(*)</span></label
                        >
                        <input
                          type="text"
                          class="form__input"
                          name="work_hour_per_month"
                          id="work_hour_per_month"
                          v-model="work_hour_per_month"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form__group">
                        <label class="form__label bold"
                          >{{ $t('wages_module.priceperhour') }}
                          <span class="required">(*)</span></label
                        >
                        <input
                          disabled
                          type="text"
                          class="form__input"
                          name="price_per_hours"
                          id="price_per_hours"
                          v-model="price_per_hours"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form__group">
                        <label class="form__label bold"
                          >{{ $t('wages_module.workinghours') }}
                          <span class="required">(*)</span></label
                        >
                        <input
                          type="text"
                          class="form__input"
                          name="working_hours"
                          id="working_hours"
                          v-model="working_hours"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form__group">
                        <label class="form__label bold"
                          >{{ $t('wages_module.grosssalarybyhours') }}
                          <span class="required">(*)</span></label
                        >
                        <input
                          disabled
                          type="text"
                          class="form__input"
                          name="gross_salary_by_hours"
                          id="gross_salary_by_hours"
                          :value="
                            parseFloat(gross_salary_by_hours) +
                            parseFloat(p_overtime_nightshift) +
                            parseFloat(p_wardship) +
                            parseFloat(p_weekend_holidays)
                          "
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="row">
                        <div class="col-8">
                          <div class="form__group">
                            <label class="form__label bold"
                              >{{ $t('wages_module.overtime-nightshift') }}
                              <span class="required">(*)</span></label
                            >
                            <input
                              type="text"
                              class="form__input"
                              name="overtime_nightshift"
                              id="overtime_nightshift"
                              v-model="overtime_nightshift"
                            />
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="form__group">
                            <label class="form__label bold"
                              ><span class="required"
                                >({{ setting_overtime }}%)</span
                              ></label
                            >
                            <input
                              disabled
                              type="text"
                              class="form__input"
                              name="p_overtime_nightshift"
                              id="p_overtime_nightshift"
                              v-model="p_overtime_nightshift"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="row">
                        <div class="col-8">
                          <div class="form__group">
                            <label class="form__label bold"
                              >{{ $t('wages_module.wardship') }}
                              <span class="required">(*)</span></label
                            >
                            <input
                              type="text"
                              class="form__input"
                              name="wardship"
                              id="wardship"
                              v-model="wardship"
                            />
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="form__group">
                            <label class="form__label bold"
                              ><span class="required"
                                >({{ setting_wardship }}%)</span
                              ></label
                            >
                            <input
                              disabled
                              type="text"
                              class="form__input"
                              name="p_wardship"
                              id="p_wardship"
                              v-model="p_wardship"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="row">
                        <div class="col-8">
                          <div class="form__group">
                            <label class="form__label bold"
                              >{{ $t('wages_module.weekendholidays') }}
                              <span class="required">(*)</span></label
                            >
                            <input
                              type="text"
                              class="form__input"
                              name="weekend_holidays"
                              id="weekend_holidays"
                              v-model="weekend_holidays"
                            />
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="form__group">
                            <label class="form__label bold"
                              ><span class="required"
                                >({{ setting_weekend_holidays }}%)</span
                              ></label
                            >
                            <input
                              disabled
                              type="text"
                              class="form__input"
                              name="p_weekend_holidays"
                              id="p_weekend_holidays"
                              v-model="p_weekend_holidays"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <div class="d-flex flex-wrap justify-content-around m-t-30">
                  <div
                    v-if="showPayrollField('tax_0_to_80_0_percent')"
                    class="boxofTax text-center"
                  >
                    <h5>{{ getPayrollLabel('tax_0_to_80_0_percent') }}</h5>
                    <h4>
                      {{
                        formatPayrollAmount(
                          calculationPreview.tax_0_to_80_0_percent
                        )
                      }}
                      {{ payrollCurrencySuffix }}
                    </h4>
                  </div>
                  <div
                    v-if="showPayrollField('tax_80_to_250_4_percent')"
                    class="boxofTax text-center"
                  >
                    <h5>{{ getPayrollLabel('tax_80_to_250_4_percent') }}</h5>
                    <h4>
                      {{
                        formatPayrollAmount(
                          calculationPreview.tax_80_to_250_4_percent
                        )
                      }}
                      {{ payrollCurrencySuffix }}
                    </h4>
                  </div>
                  <div
                    v-if="showPayrollField('tax_250_to_450_8_percent')"
                    class="boxofTax text-center"
                  >
                    <h5>{{ getPayrollLabel('tax_250_to_450_8_percent') }}</h5>
                    <h4>
                      {{
                        formatPayrollAmount(
                          calculationPreview.tax_250_to_450_8_percent
                        )
                      }}
                      {{ payrollCurrencySuffix }}
                    </h4>
                  </div>
                  <div
                    v-if="showPayrollField('tax_greater_450_10_percent')"
                    class="boxofTax text-center"
                  >
                    <h5>{{ getPayrollLabel('tax_greater_450_10_percent') }}</h5>
                    <h4>
                      {{
                        formatPayrollAmount(
                          calculationPreview.tax_greater_450_10_percent
                        )
                      }}
                      {{ payrollCurrencySuffix }}
                    </h4>
                  </div>
                  <div
                    v-if="showPayrollField('contribution_5_percent')"
                    class="boxofTax text-center"
                  >
                    <h5>{{ getPayrollLabel('contribution_5_percent') }}</h5>
                    <h4>
                      {{
                        formatPayrollAmount(
                          calculationPreview.contribution_5_percent
                        )
                      }}
                      {{ payrollCurrencySuffix }}
                    </h4>
                  </div>
                  <div class="boxofTax text-center">
                    <h5>Total Tax</h5>
                    <h4>
                      {{ formatPayrollAmount(calculationPreview.total_tax) }}
                      {{ payrollCurrencySuffix }}
                    </h4>
                  </div>
                  <div class="boxofTax text-center">
                    <h5 class="f-w">Net Salary</h5>
                    <h4>
                      {{ formatPayrollAmount(calculationPreview.net_salary) }}
                      {{ payrollCurrencySuffix }}
                    </h4>
                  </div>
                </div>
                <div class="row m-t-30">
                  <div class="col-md-12">
                    <div class="text-center">
                      <button type="submit" class="site_btn btn_blue">
                        {{ $t('wages_module.save') }}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="profile_edit_modals" v-if="export_modal">
      <div class="modal_item">
        <div class="box">
          <div class="close_modal" @click="export_modal = false">
            <img src="/images/close.svg" width="20px" />
          </div>
          <div class="container m-t-b">
            <div class="addExperienceSection">
              <form class="form-type-1" @submit.prevent="initiateExport">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form__group">
                      <label for="export_year" class="form__label bold"
                        >{{ $t('wages_module.selectyear') }}
                        <span class="required">(*)</span></label
                      >
                      <multiselect
                        v-validate="'required'"
                        id="export_year"
                        name="export_year"
                        v-model="export_year"
                        :options="selected_yearOptions"
                        placeholder="Select year"
                        label="name"
                        track-by="value"
                      />
                      <span
                        v-show="errors.has('export_year')"
                        class="form-error-notification error"
                      >
                        {{ $t('inputError.required') }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form__group">
                      <label for="export_month" class="form__label bold"
                        >{{ $t('wages_module.selectmonth') }}
                        <span class="required">(*)</span></label
                      >
                      <multiselect
                        v-validate="'required'"
                        id="export_month"
                        name="export_month"
                        v-model="export_month"
                        :options="selected_monthOptions"
                        placeholder="Select month"
                        label="name"
                        track-by="value"
                      />
                      <span
                        v-show="errors.has('export_month')"
                        class="form-error-notification error"
                      >
                        {{ $t('inputError.required') }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form__group">
                      <label for="export_language" class="form__label bold"
                        >{{ $t('wages_module.export_language') }}
                        <span class="required">(*)</span></label
                      >
                      <multiselect
                        v-validate="'required'"
                        id="export_language"
                        name="export_language"
                        v-model="export_language"
                        :options="export_language_options"
                        :placeholder="$t('wages_module.export_language')"
                        label="name"
                        track-by="value"
                      />
                      <span
                        v-show="errors.has('export_language')"
                        class="form-error-notification error"
                      >
                        {{ $t('inputError.required') }}
                      </span>
                    </div>
                  </div>
                  <!-- <div class="col-md-4">
                                        <div class="form__group">
                                            <label for="descriptionWages" class="form__label bold">{{ $t('wages_module.description') }} <span class="required">(*)</span></label>
                                            <input v-validate="'required'" class="form__input" id="descriptionWages" type="text" :placeholder="$t('employee_module.description')" v-model="descriptionWages" name="descriptionWages" />
                                            <span v-show="errors.has('descriptionWages')" class="form-error-notification error">
                                                {{ $t('inputError.required') }}
                                            </span>
                                        </div>
                                    </div> -->
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="text-center">
                      <button type="submit" class="site_btn btn_export">
                        {{ $t('wages_module.export') }}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="profile_edit_modals" v-if="tax_declaration_modal">
      <div class="modal_item">
        <div class="box">
          <div class="close_modal" @click="tax_declaration_modal = false">
            <img src="/images/close.svg" width="20px" />
          </div>
          <div class="container m-t-b">
            <div class="addExperienceSection">
              <form
                class="form-type-1"
                @submit.prevent="generateTaxDeclaration"
              >
                <div class="row">
                  <div class="col-md-6">
                    <div class="form__group">
                      <label for="export_year" class="form__label bold"
                        >{{ $t('wages_module.selectyear') }}
                        <span class="required">(*)</span></label
                      >
                      <multiselect
                        v-validate="'required'"
                        id="export_year"
                        name="export_year"
                        v-model="export_year"
                        :options="selected_yearOptions"
                        placeholder="Select year"
                        label="name"
                        track-by="value"
                      />
                      <span
                        v-show="errors.has('export_year')"
                        class="form-error-notification error"
                      >
                        {{ $t('inputError.required') }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form__group">
                      <label for="export_month" class="form__label bold"
                        >{{ $t('wages_module.selectmonth') }}
                        <span class="required">(*)</span></label
                      >
                      <multiselect
                        v-validate="'required'"
                        id="export_month"
                        name="export_month"
                        v-model="export_month"
                        :options="selected_monthOptions"
                        placeholder="Select month"
                        label="name"
                        track-by="value"
                      />
                      <span
                        v-show="errors.has('export_month')"
                        class="form-error-notification error"
                      >
                        {{ $t('inputError.required') }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="text-center">
                      <button type="submit" class="site_btn btn_export">
                        {{ $t('wages_module.export') }}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import employeeSearch from '@company_components/jobs/data-search'
import * as XLSX from 'xlsx'
import {
  formatPayrollAmount as formatCurrencyAwarePayrollAmount,
  formatCurrencySuffix,
  getCurrencyOption,
  getCountryLabel,
  getPayrollFieldLabel,
  getUnsupportedPayrollExecutionMessage,
  getUnsupportedPayrollExecutionMessageKey,
  isPayrollExecutionSupported,
  isSecondJobSupported,
  normalizeCountryCode,
  shouldShowPayrollField
} from '@/helpers/payrollCountry'
import { buildAlbaniaWageCalculationPreview } from '@/helpers/albaniaPayrollPreview'

function toPayrollNumber(value) {
  const parsed = parseFloat(value)
  return Number.isFinite(parsed) ? parsed : 0
}

function roundPayrollAmount(value) {
  return Math.round(toPayrollNumber(value) * 1000) / 1000
}

function reverseKosovoPayrollCalculation(
  netSalary,
  isSecondJob,
  payTax,
  payContribution
) {
  let tax4 = 0
  let tax8 = 0
  let tax10 = 0

  if (isSecondJob) {
    tax10 = roundPayrollAmount((netSalary / 0.9) * 0.1)
  } else {
    let diffTax80To250 = netSalary
    if (diffTax80To250 > 170) {
      diffTax80To250 = 170
    }
    if (netSalary <= 80) {
      diffTax80To250 = 0
    }

    if (diffTax80To250 === 170) {
      let diffTax250To450 = (netSalary + tax4 - 250) / 0.92
      if (diffTax250To450 > 200) {
        diffTax250To450 = 200
      }
      tax8 = roundPayrollAmount(diffTax250To450 * 0.08)

      if (diffTax250To450 === 200) {
        const diffTax450 = (netSalary + tax4 + tax8 - 450) / 0.9
        tax10 = roundPayrollAmount(diffTax450 * 0.1)
      }
    }
  }

  const totalTax = payTax ? roundPayrollAmount(tax4 + tax8 + tax10) : 0
  const taxableIncome = roundPayrollAmount(totalTax + netSalary)
  const contribution = payContribution
    ? roundPayrollAmount(taxableIncome / 0.95 - taxableIncome)
    : 0

  return {
    contribution,
    bruto: roundPayrollAmount(taxableIncome + contribution),
    tax_0_to_80_0_percent: 0,
    tax_80_to_250_4_percent: payTax ? tax4 : 0,
    tax_250_to_450_8_percent: payTax ? tax8 : 0,
    tax_greater_450_10_percent: payTax ? tax10 : 0,
    total_tax: totalTax
  }
}

function buildWageCalculationPreview({
  companyCountry,
  baseGrossSalary,
  advancePayment,
  bonusPayment,
  healthInsuranceCost,
  isSecondJob,
  leaveWithoutPayment,
  payContribution,
  payTax,
  pensionDeduction
}) {
  const taxableGrossSalary = roundPayrollAmount(
    baseGrossSalary - leaveWithoutPayment + bonusPayment
  )

  if (companyCountry === 'alb') {
    return buildAlbaniaWageCalculationPreview({
      baseGrossSalary,
      advancePayment,
      bonusPayment,
      healthInsuranceCost,
      leaveWithoutPayment,
      payTax,
      payContribution,
      pensionDeduction
    })
  }

  const contribution = payContribution
    ? roundPayrollAmount(taxableGrossSalary * 0.05)
    : 0
  const grossSalaryWithoutContribution = payContribution
    ? roundPayrollAmount(taxableGrossSalary - contribution)
    : taxableGrossSalary

  let tax80To250 = 0
  let tax250To450 = 0
  let taxGreaterThan450 = 0
  let totalTax = 0

  if (isSecondJob) {
    taxGreaterThan450 = payTax
      ? roundPayrollAmount(grossSalaryWithoutContribution * 0.1)
      : 0
    totalTax = taxGreaterThan450
  } else if (payTax) {
    tax250To450 =
      grossSalaryWithoutContribution < 250
        ? 0
        : Math.min((grossSalaryWithoutContribution - 250) * 0.08, 16)
    tax250To450 = roundPayrollAmount(tax250To450)

    taxGreaterThan450 =
      grossSalaryWithoutContribution < 450
        ? 0
        : roundPayrollAmount((grossSalaryWithoutContribution - 450) * 0.1)

    totalTax = roundPayrollAmount(tax80To250 + tax250To450 + taxGreaterThan450)
  }

  const grossForNetSalary = payContribution
    ? grossSalaryWithoutContribution
    : taxableGrossSalary
  const netSalary = roundPayrollAmount(
    grossForNetSalary - totalTax - advancePayment
  )
  const reverseCalculation =
    healthInsuranceCost > 0
      ? reverseKosovoPayrollCalculation(
          netSalary + healthInsuranceCost,
          isSecondJob,
          payTax,
          payContribution
        )
      : null

  return {
    contribution_5_percent: reverseCalculation
      ? reverseCalculation.contribution
      : contribution,
    health_insurance_gross: reverseCalculation
      ? roundPayrollAmount(reverseCalculation.bruto - taxableGrossSalary)
      : 0,
    net_salary: netSalary,
    tax_0_to_80_0_percent: 0,
    tax_80_to_250_4_percent: reverseCalculation
      ? reverseCalculation.tax_80_to_250_4_percent
      : tax80To250,
    tax_250_to_450_8_percent: reverseCalculation
      ? reverseCalculation.tax_250_to_450_8_percent
      : tax250To450,
    tax_greater_450_10_percent: reverseCalculation
      ? reverseCalculation.tax_greater_450_10_percent
      : taxGreaterThan450,
    total_salary: roundPayrollAmount(netSalary + healthInsuranceCost),
    total_tax: reverseCalculation ? reverseCalculation.total_tax : totalTax
  }
}

export default {
  inject: {
    $validator: '$validator'
  },

  components: {
    'generated-wages-employee': employeeSearch
  },

  mounted() {
    // Add your code here that needs to run when the component is mounted
    this.generate_wages_selected_year = {
      name: '2025',
      value: '2025'
    }

    this.onGenerateWagesYearSelect({
      name: '2025',
      value: '2025'
    })

    // Check if company_monthly_generated_salary_list is empty
    if (
      !this.company_monthly_generated_salary_list ||
      this.company_monthly_generated_salary_list?.data?.length
    ) {
      this.generate_wages_disabled = true // Disable generate wages
    } else {
      this.generate_wages_disabled = false // Enable generate wages
    }
  },

  computed: {
    current_site_language() {
      this.fillMonthOptions(this.$i18n.locale())
      return this.$i18n.locale()
    },
    companyProfileData() {
      return this.$store.getters['company_data/get'] || {}
    },
    companyCountry() {
      return normalizeCountryCode(this.companyProfileData.country_value)
    },
    payrollExecutionSupported() {
      return isPayrollExecutionSupported(this.companyCountry)
    },
    unsupportedPayrollExecutionMessage() {
      const translationKey = getUnsupportedPayrollExecutionMessageKey(
        this.companyCountry
      )

      if (translationKey) {
        return this.$t(translationKey)
      }

      return getUnsupportedPayrollExecutionMessage(this.companyCountry)
    },
    companyPayrollCurrencyCode() {
      return (
        this.companyProfileData.main_currency ||
        formatCurrencySuffix(this.companyCountry)
      )
    },
    payrollCurrencySuffix() {
      return formatCurrencySuffix(this.companyCountry)
    },
    supportsSecondJob() {
      return isSecondJobSupported(this.companyCountry)
    },

    company_monthly_generated_salary_list: function () {
      if (
        this.$store.getters[
          'company_data/employee/finances/get_monthly_generated_salaries'
        ]
      ) {
        return this.$store.getters[
          'company_data/employee/finances/get_monthly_generated_salaries'
        ]
      }

      return {
        data: [],
        total: 0,
        current_page: 1,
        per_page: 10
      }
    },

    visibleGeneratedSalaries() {
      const salaries = this.company_monthly_generated_salary_list.data || []

      if (this.filtered) {
        return salaries
      }

      return salaries.filter((item) => item.closed === 0)
    },

    calculationPreview() {
      const baseGrossSalary = this.workinghours
        ? toPayrollNumber(this.gross_salary_by_hours) +
          toPayrollNumber(this.p_overtime_nightshift) +
          toPayrollNumber(this.p_wardship) +
          toPayrollNumber(this.p_weekend_holidays)
        : toPayrollNumber(this.gross_salary)

      return buildWageCalculationPreview({
        companyCountry: this.companyCountry,
        baseGrossSalary,
        advancePayment: toPayrollNumber(this.edit_advance_payment),
        bonusPayment: toPayrollNumber(this.edit_bonus_payment),
        healthInsuranceCost: toPayrollNumber(this.edit_health_insurance_cost),
        isSecondJob: Boolean(Number(this.edit_job_rank)),
        leaveWithoutPayment: toPayrollNumber(this.edit_leave_without_payment),
        payContribution: Boolean(Number(this.payContribution)),
        payTax: Boolean(Number(this.payTax)),
        pensionDeduction: toPayrollNumber(this.edit_pension_deduction)
      })
    },

    calculation() {
      return this.calculationPreview.net_salary.toFixed(2)
    }
  },

  watch: {
    gross_salary(newVal) {
      this.gross_salary = newVal.replace(/,/g, '')
    },
    edit_gross_salary(newVal) {
      this.edit_gross_salary = newVal.replace(/,/g, '')
    },
    net_salary(newVal) {
      this.net_salary = newVal.replace(/,/g, '')
    },
    work_hour_per_month(newValue) {
      if (this.can_update) {
        if (newValue > 0) {
          this.price_per_hours = this.gross_salary / newValue
          this.price_per_hours = parseFloat(this.price_per_hours).toFixed(2)
        } else {
          this.price_per_hours = 0
        }
        this.working_hours = 0
        this.overtime_nightshift = 0
        this.wardship = 0
        this.weekend_holidays = 0
        this.p_overtime_nightshift = 0
        this.p_wardship = 0
        this.p_weekend_holidays = 0
      }
    },

    working_hours(newValue) {
      if (this.can_update) {
        if (newValue >= 0) {
          this.gross_salary_by_hours =
            this.price_per_hours * parseFloat(newValue).toFixed(2)
          this.gross_salary_by_hours = parseFloat(
            this.gross_salary_by_hours
          ).toFixed(2)
          this.saved_gross_salary_by_hours = this.gross_salary_by_hours
        } else {
          this.gross_salary_by_hours = 0
          this.saved_gross_salary_by_hours = 0
        }
        this.overtime_nightshift = 0
        this.wardship = 0
        this.weekend_holidays = 0
        this.p_overtime_nightshift = 0
        this.p_wardship = 0
        this.p_weekend_holidays = 0
      }
    },

    overtime_nightshift(newValue) {
      if (this.can_update) {
        if (newValue > 0 && this.working_hours > 0) {
          const percentageToAdd = parseFloat(this.setting_overtime)
          const total = parseFloat(newValue) * this.price_per_hours
          const amountToAdd = (percentageToAdd / 100) * total
          this.p_overtime_nightshift =
            parseFloat(amountToAdd) + parseFloat(total)
          this.p_overtime_nightshift = this.p_overtime_nightshift.toFixed(2)
        } else {
          this.overtime_nightshift = 0
          this.p_overtime_nightshift = 0
        }
      }
    },

    wardship(newValue) {
      if (this.can_update) {
        if (newValue > 0 && this.working_hours > 0) {
          const percentageToAdd = parseFloat(this.setting_wardship)
          const total = parseFloat(newValue) * this.price_per_hours
          const amountToAdd = (percentageToAdd / 100) * total
          this.p_wardship = parseFloat(amountToAdd) + parseFloat(total)
          this.p_wardship = this.p_wardship.toFixed(2)
        } else {
          this.wardship = 0
          this.p_wardship = 0
        }
      }
    },

    weekend_holidays(newValue) {
      if (this.can_update) {
        if (newValue > 0 && this.working_hours > 0) {
          const percentageToAdd = parseFloat(this.setting_weekend_holidays)
          const total = parseFloat(newValue) * this.price_per_hours
          const amountToAdd = (percentageToAdd / 100) * total
          this.p_weekend_holidays = parseFloat(amountToAdd) + parseFloat(total)
          this.p_weekend_holidays = this.p_weekend_holidays.toFixed(2)
        } else {
          this.weekend_holidays = 0
          this.p_weekend_holidays = 0
        }
      }
    },

    current_site_language(newValue) {
      this.fillMonthOptions(newValue)
    },

    company_monthly_generated_salary_list: function (new_value) {
      const closedRecordYears = {}
      this.has_open_records = false

      for (const record of new_value.data) {
        if (!record.closed) {
          this.has_open_records = true
        } else {
          if (!closedRecordYears[record.year]) {
            closedRecordYears[record.year] = []
          }

          if (!closedRecordYears[record.year].includes(record.month)) {
            closedRecordYears[record.year].push(record.month)
          }
        }
      }

      this.closed_record_years = closedRecordYears
      this.updateGenerateWagesYearOptions()

      return new_value
    }
  },

  data() {
    return {
      generate_wages_disabled: false,
      component_loading: true,
      submitted: false,
      modal: false,
      export_modal: false,
      filtermodal: false,
      filtered: false,

      edit_modal: false,
      tax_declaration_modal: false,

      workinghours: false,

      p_overtime_nightshift: '',
      p_wardship: '',
      p_weekend_holidays: '',

      export_language: [],
      export_language_options: [
        {
          name: 'English',
          value: 'en'
        },
        {
          name: 'Albanian',
          value: 'alb'
        }
      ],

      selected_year: [],
      export_year: {
        name: this.getCurrentYear(),
        value: this.getCurrentYear()
      },
      closed_record_years: {},
      selected_yearOptions: [
        {
          name: '2021',
          value: '2021'
        },
        {
          name: '2022',
          value: '2022'
        },
        {
          name: '2023',
          value: '2023'
        },
        {
          name: '2024',
          value: '2024'
        },
        {
          name: '2025',
          value: '2025'
        },
        {
          name: '2026',
          value: '2026'
        }
      ],
      generate_wages_year_options: [
        {
          name: '2021',
          value: '2021'
        },
        {
          name: '2022',
          value: '2022'
        },
        {
          name: '2023',
          value: '2023'
        },
        {
          name: '2024',
          value: '2024'
        },
        {
          name: '2025',
          value: '2025'
        },
        {
          name: '2026',
          value: '2026'
        }
      ],
      generate_wages_selected_year: [],
      generate_wages_selected_month: [],
      selected_month: [],
      export_month: {},
      selected_monthOptions: [],
      generate_wages_month_options: [],

      actions: false,
      actionId: '',

      edit_year: '',
      edit_month: '',
      edit_gross_salary: '',
      edit_health_insurance_cost: '',
      edit_health_insuranace_gross: '',
      edit_job_rank: '',
      edit_advance_payment: '',
      edit_leave_without_payment: '',
      edit_bonus_payment: '',
      edit_pension_deduction: '',
      edit_meals_payment: '',

      tax_0_to_80_0_percent: '',
      tax_80_to_250_4_percent: '',
      tax_250_to_450_8_percent: '',
      tax_greater_450_10_percent: '',
      total_tax: '',
      contribution_5_percent: '',

      tax_0_to_80_0_percent_with_health_insurance: '',
      tax_80_to_250_4_percent_with_health_insurance: '',
      tax_250_to_450_8_percent_with_health_insurance: '',
      tax_greater_450_10_percent_with_health_insurance: '',
      total_tax_with_health_insurance: '',
      contribution_5_percent_with_health_insurance: '',

      setting_tax_0_to_80_0_percent: '',
      setting_tax_80_to_250_4_percent: '',
      setting_tax_250_to_450_8_percent: '',
      setting_tax_greater_450_10_percent: '',
      setting_total_tax: '',
      setting_contribution: '',
      setting_overtime: '',
      setting_wardship: '',
      setting_weekend_holidays: '',

      fromnetotobruto: 0,

      net_salary: '',
      gross_salary: '',
      health_insurance_cost: '',

      work_hour_per_month: 0,
      price_per_hours: '',
      working_hours: '',
      gross_salary_by_hours: '',
      saved_gross_salary_by_hours: '',
      can_update: false,

      overtime_nightshift: '',
      wardship: '',
      weekend_holidays: '',

      wage_edit_id: '',

      has_open_records: false,
      descriptionWages: '',

      payTax: '',
      payContribution: ''
    }
  },

  methods: {
    getPayrollLabel(fieldKey) {
      return getPayrollFieldLabel(this.companyCountry, fieldKey)
    },
    showPayrollField(fieldKey) {
      return shouldShowPayrollField(this.companyCountry, fieldKey)
    },
    getDisplayedCurrencyCode(salaryItem) {
      return salaryItem.company_currency || this.companyPayrollCurrencyCode
    },
    getSourceCurrencyLabel(salaryItem) {
      return getCurrencyOption(salaryItem && salaryItem.payment_currency).label
    },
    isCurrencyConverted(salaryItem) {
      return Boolean(salaryItem && salaryItem.is_currency_converted)
    },
    formatConversionRate(salaryItem) {
      const conversionRate = Number(salaryItem && salaryItem.conversion_rate)
      return Number.isFinite(conversionRate)
        ? conversionRate.toFixed(4)
        : salaryItem.conversion_rate
    },
    formatPayrollAmount(value, salaryItem = null) {
      const currencyCode = salaryItem
        ? this.getDisplayedCurrencyCode(salaryItem)
        : this.companyPayrollCurrencyCode

      return formatCurrencyAwarePayrollAmount(value, currencyCode)
    },
    getPayrollExportCurrencyCode() {
      return this.companyPayrollCurrencyCode
    },
    getPayrollExportCountryLabel() {
      return getCountryLabel(this.companyCountry)
    },
    normalizeTaxDeclarationBoolean(value) {
      const normalized = String(value || '')
        .trim()
        .toLowerCase()

      return normalized === 'po' || normalized === 'yes' || normalized === '1'
    },
    getExportBooleanLabel(value) {
      if (this.export_language.value === 'alb') {
        return value ? 'Po' : 'Jo'
      }

      return value ? 'Yes' : 'No'
    },
    getNoPayrollRecordsMessage() {
      return this.$t('wages_module.no_salaries_available_for_period', {
        month: this.export_month.name,
        year: this.export_year.value
      })
    },
    getPayrollExportFilename(type) {
      const normalizedCountry = this.getPayrollExportCountryLabel()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '')

      return `HrBee_${type}_${normalizedCountry}_${this.export_year.value}_${this.export_month.value}.xlsx`
    },
    getTaxDeclarationHeaders() {
      const currencyCode = this.getPayrollExportCurrencyCode()

      if (this.export_language.value === 'alb') {
        return {
          title: 'Deklarim tatimor',
          columns: [
            'Emri',
            'Mbiemri',
            'Numri personal',
            `Paga bruto (${currencyCode})`,
            'Kontributi i punëmarrësit',
            'Kontributi i punëdhënësit',
            'Kontributi shtesë i punëmarrësit',
            'Kontributi shtesë i punëdhënësit',
            'Punë primare',
            'Përfshihen kontributet',
            'Aplikohet tatimi në paga'
          ]
        }
      }

      return {
        title: 'Tax declaration',
        columns: [
          'Name',
          'Surname',
          'Personal ID',
          `Gross salary (${currencyCode})`,
          'Employee contribution',
          'Employer contribution',
          'Additional employee contribution',
          'Additional employer contribution',
          'Primary job',
          'Includes contributions',
          'Applies payroll tax'
        ]
      }
    },
    getCurrentYear() {
      return new Date().getFullYear()
    },
    ensurePayrollExecutionSupported() {
      if (this.payrollExecutionSupported) {
        return true
      }

      this.$toast.warning(this.unsupportedPayrollExecutionMessage, 'Warning', {
        timeut: 3000
      })

      return false
    },
    getCurrentMonth() {
      return new Date().getMonth()
    },
    onGenerateWagesYearSelect: function (data) {
      const year = data && data.value ? data.value : null

      if (year) {
        for (let month of this.generate_wages_month_options) {
          month.$isDisabled =
            this.closed_record_years[year] &&
            this.closed_record_years[year].includes(month.value)
        }
      }
    },

    openTaxDeclarationModal: function () {
      if (!this.ensurePayrollExecutionSupported()) {
        return
      }

      this.tax_declaration_modal = true
      this.export_month = []
      this.export_year = []
    },

    generateTaxDeclaration: function () {
      if (!this.ensurePayrollExecutionSupported()) {
        return
      }

      this.$validator.validate().then((valid) => {
        if (valid) {
          let data = {
            year: this.export_year.value,
            month: this.export_month.value
          }
          this.$store
            .dispatch(
              'company_data/employee/finances/generate_tax_declaration',
              data
            )
            .then((response) => {
              if (!response.data) {
                return this.$toast.warning(
                  this.getNoPayrollRecordsMessage(),
                  'Warning',
                  { timeut: 3000 }
                )
              }
              if (response.status != 200) throw response.data[0]
              const taxDeclarationHeaders = this.getTaxDeclarationHeaders()
              const wb = XLSX.utils.book_new()
              const ws = XLSX.utils.aoa_to_sheet([
                taxDeclarationHeaders.columns
              ])
              XLSX.utils.book_append_sheet(wb, ws, taxDeclarationHeaders.title)
              const header2 = [
                'a',
                'b',
                'c',
                'd',
                'e=(d*5%)',
                'f=(d*5%)',
                'g',
                'h',
                'i',
                'j',
                'k'
              ]
              const rows = [header2]
              let itemCount = 0
              response.data.forEach((item) => {
                const grossSalary = parseFloat(item.gross_salary).toFixed(2)
                const contribution = parseFloat(
                  item.contribution_5_percent
                ).toFixed(2)
                const row = [
                  item.name,
                  item.surname,
                  item.personal_id,
                  grossSalary,
                  contribution,
                  contribution,
                  item.empty_box,
                  item.empty_box,
                  this.getExportBooleanLabel(
                    this.normalizeTaxDeclarationBoolean(item.is_second_job)
                  ),
                  this.getExportBooleanLabel(
                    this.normalizeTaxDeclarationBoolean(item.pay_contribution)
                  ),
                  this.getExportBooleanLabel(
                    this.normalizeTaxDeclarationBoolean(item.pay_tax)
                  )
                ]
                rows.push(row)
                itemCount++
              })
              const newLine2 = rows
              XLSX.utils.sheet_add_aoa(ws, newLine2, { origin: -1 })
              for (let i = 3; i < itemCount + 3; i++) {
                ws[`D${i}`].t = 'n'
                ws[`E${i}`].t = 'n'
                ws[`F${i}`].t = 'n'
              }
              XLSX.writeFile(
                wb,
                this.getPayrollExportFilename('tax_declaration')
              )

              this.export_month = []
              this.export_year = []
              this.tax_declaration_modal = false
            })
            .catch((err) => {
              console.error(err)
              this.$toast.warning('Something went wrong', 'warning', {
                timeut: 3000
              })
            })
        }
      })
    },

    floatToStringWithCommaSeparator(floatValue) {
      return floatValue.toString().replace('.', ',')
    },

    getMonth(lang, month) {
      if (lang === 'alb') {
        switch (month) {
          case 1:
            return 'Janar'
          case 2:
            return 'Shkurt'
          case 3:
            return 'Mars'
          case 4:
            return 'Prill'
          case 5:
            return 'Maj'
          case 6:
            return 'Qershor'
          case 7:
            return 'Korrik'
          case 8:
            return 'Gusht'
          case 9:
            return 'Shtator'
          case 10:
            return 'Tetor'
          case 11:
            return 'Nëntor'
          case 12:
            return 'Dhjetor'
        }
      } else {
        switch (month) {
          case 1:
            return 'January'
          case 2:
            return 'February'
          case 3:
            return 'March'
          case 4:
            return 'April'
          case 5:
            return 'May'
          case 6:
            return 'June'
          case 7:
            return 'July'
          case 8:
            return 'August'
          case 9:
            return 'September'
          case 10:
            return 'October'
          case 11:
            return 'November'
          case 12:
            return 'December'
        }
      }
    },

    initiateExport: function () {
      if (!this.ensurePayrollExecutionSupported()) {
        return
      }

      this.$validator.validate().then((valid) => {
        if (valid) {
          let data = {
            year: this.export_year.value,
            month: this.export_month.value,
            description: '',
            SERVER_URL: this.SERVER_URL,
            SALARIES_EXPORT_FOLDER: this.SALARIES_EXPORT_FOLDER
          }
          this.$store
            .dispatch(
              'company_data/employee/finances/generate_salaries_in_csv',
              data
            )
            .then((response) => {
              if (!response.data) {
                return this.$toast.warning(
                  this.getNoPayrollRecordsMessage(),
                  'warning',
                  { timeut: 3000 }
                )
              }

              const headerName =
                this.export_language.value === 'alb'
                  ? 'Emri & Mbiemri'
                  : 'Name & Surname'
              const headerPersonalId =
                this.export_language.value === 'alb'
                  ? 'Id Personale'
                  : 'Personal ID'
              const headerEmpBankName =
                this.export_language.value === 'alb'
                  ? 'Emri i bankës së punëtorit'
                  : 'Employee Bank Name'
              const headerEmpBankAccountNumber =
                this.export_language.value === 'alb'
                  ? 'Numri i xhirollogarisë'
                  : 'Bank Account Number'
              const headerBonus = 'Bonus'
              const headerBonusNote =
                this.export_language.value === 'alb'
                  ? 'Shënimi i bonusit'
                  : 'Bonus Note'
              const headerPaymentCurrency =
                this.export_language.value === 'alb'
                  ? 'Valuta e pagesës'
                  : 'Payment Currency'
              const headerShownIn =
                this.export_language.value === 'alb' ? 'Shfaqur në' : 'Shown In'
              const headerConversionRate =
                this.export_language.value === 'alb'
                  ? 'Kursi i konvertimit'
                  : 'Conversion Rate'
              const currencyCode = this.getPayrollExportCurrencyCode()
              const headerBruto =
                this.export_language.value === 'alb'
                  ? `Bruto paga (${currencyCode})`
                  : `Bruto Salary (${currencyCode})`
              const headerNet =
                this.export_language.value === 'alb'
                  ? `Neto paga (${currencyCode})`
                  : `Net Salary (${currencyCode})`
              const headerDescription =
                this.export_language.value === 'alb'
                  ? 'Përshkrimi'
                  : 'Description'
              const headerTotalAmount =
                this.export_language.value === 'alb' ? 'Totali' : 'Total Amount'

              const headerSalaryFor =
                this.export_language.value === 'alb' ? 'Paga për' : 'Salary for'

              const wb = XLSX.utils.book_new()
              const ws = XLSX.utils.aoa_to_sheet([
                [
                  headerName,
                  headerPersonalId,
                  headerEmpBankName,
                  headerEmpBankAccountNumber,
                  headerPaymentCurrency,
                  headerShownIn,
                  headerConversionRate,
                  headerBonus,
                  headerBonusNote,
                  headerBruto,
                  headerNet,
                  headerDescription
                ]
              ])
              XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
              const rows = []
              let grossSalaryTotal = 0
              let netSalaryTotal = 0
              response.data.forEach((item) => {
                // Format bonus_payment, gross_salary, net_salary to 2 decimals
                const bonusPayment = parseFloat(item.bonus_payment)
                const grossSalary = parseFloat(item.gross_salary)
                const netSalary = parseFloat(item.net_salary)
                const displayedCurrency =
                  item.company_currency || this.companyPayrollCurrencyCode
                const conversionRate = Number(item.conversion_rate)
                const row = [
                  `${item.name} ${item.surname}`,
                  item.personal_id,
                  item.employee_bank_name,
                  item.employee_bank_account_number,
                  item.payment_currency || displayedCurrency,
                  displayedCurrency,
                  Number.isFinite(conversionRate)
                    ? conversionRate.toFixed(4)
                    : '',
                  bonusPayment.toFixed(2),
                  item.bonus_note,
                  (grossSalary + bonusPayment).toFixed(2),
                  netSalary.toFixed(2),
                  `${headerSalaryFor} ${this.getMonth(this.export_language.value, item.month)} ${item.year}`
                ]
                rows.push(row)
                grossSalaryTotal += grossSalary + bonusPayment
                netSalaryTotal += netSalary
              })

              rows.push([])
              rows.push([])
              rows.push([
                '',
                '',
                '',
                '',
                headerTotalAmount,
                grossSalaryTotal.toFixed(2),
                netSalaryTotal.toFixed(2),
                ''
              ])
              const newLine2 = rows
              XLSX.utils.sheet_add_aoa(ws, newLine2, { origin: -1 })

              XLSX.writeFile(wb, this.getPayrollExportFilename('salaries'))
            })
            .catch((err) => {
              console.error(err)
              this.$toast.warning('Something went wrong', 'warning', {
                timeut: 3000
              })
            })
        }
      })
    },

    toggleTerms: function (checked) {
      if (checked) {
        this.workinghours = true
      } else {
        this.workinghours = false
        this.working_hours = 0
        this.work_hour_per_month = 0
        this.weekend_holidays = 0
        this.wardship = 0
        this.overtime_nightshift = 0
        this.price_per_hours = 0
        this.gross_salary_by_hours = 0
      }
    },

    deleteMonthlyReport: function (monthly_salary_id) {
      this.$toast.question(
        this.$t('alerts.are_you_sure'),
        this.$t('alerts.confirm'),
        {
          timeout: 20000,
          close: false,
          overlay: true,
          displayMode: 'once',
          id: 'question',
          zindex: 999,
          title: 'Hey',
          position: 'center',
          buttons: [
            [
              '<button><b>YES</b></button>',
              (instance, toast) => {
                this.component_loading = true
                setTimeout(() => {
                  this.$store
                    .dispatch(
                      'company_data/employee/finances/delete_employee_salary_generation',
                      monthly_salary_id
                    )
                    .then(() => {
                      this.$toast.error(
                        this.$t('wages_module-alerts.wagedelete'),
                        'Success',
                        { timeut: 3000 }
                      )
                      this.component_loading = false
                      this.getAllGeneratedWages()
                    })
                }, 500)

                instance.hide({ transitionOut: 'fadeOut' }, toast, 'button')
              },
              true
            ],
            [
              '<button>NO</button>',
              function (instance, toast) {
                instance.hide({ transitionOut: 'fadeOut' }, toast, 'button')
              }
            ]
          ]
        }
      )
    },

    updateWage() {
      if (!this.ensurePayrollExecutionSupported()) {
        return
      }

      const calculationPreview = this.calculationPreview

      let data = {
        monthly_salary_id: this.wage_edit_id,
        advance_payment: this.edit_advance_payment,
        bonus_payment: this.edit_bonus_payment,
        contribution_5_percent: calculationPreview.contribution_5_percent,
        gross_salary_by_hours:
          parseFloat(this.gross_salary_by_hours) +
          parseFloat(this.p_overtime_nightshift) +
          parseFloat(this.p_wardship) +
          parseFloat(this.p_weekend_holidays),
        leave_without_payment: this.edit_leave_without_payment,
        meals_payment: this.edit_meals_payment,
        net_salary: calculationPreview.net_salary,
        pension_deduction: this.edit_pension_deduction,
        tax_0_to_80_0_percent: calculationPreview.tax_0_to_80_0_percent,
        tax_80_to_250_4_percent: calculationPreview.tax_80_to_250_4_percent,
        tax_250_to_450_8_percent: calculationPreview.tax_250_to_450_8_percent,
        tax_greater_450_10_percent:
          calculationPreview.tax_greater_450_10_percent,
        total_tax: calculationPreview.total_tax,
        overtime_nightshift: this.overtime_nightshift,
        price_per_hours: this.price_per_hours,
        wardship: this.wardship,
        weekend_holidays: this.weekend_holidays,
        work_hour_per_month: this.work_hour_per_month,
        working_hours: this.working_hours,
        health_insurance_cost: this.edit_health_insurance_cost,
        health_insurance_gross: calculationPreview.health_insurance_gross,
        total_salary: calculationPreview.total_salary
      }

      this.$store
        .dispatch(
          'company_data/employee/finances/edit_generated_monthly_salary_for_single_employee',
          data
        )
        .then(() => {
          this.$toast.success(
            this.$t('wages_module-alerts.wageupdated'),
            'Success',
            { timeut: 3000 }
          )
          this.edit_modal = false
          this.getAllGeneratedWages()
        })
    },

    openModalEdit(id) {
      if (!this.ensurePayrollExecutionSupported()) {
        return
      }

      this.edit_modal = true
      this.wage_edit_id = id
      this.can_update = false

      this.$store
        .dispatch(
          'company_data/employee/finances/get_single_employee_monthly_salary_gen',
          id
        )
        .then((response) => {
          this.edit_year = response.data.year
          this.edit_month = response.data.month
          this.edit_gross_salary = response.data.gross_salary
          this.edit_job_rank = response.data.is_second_job
          this.edit_advance_payment = response.data.advance_payment
          this.edit_leave_without_payment = response.data.leave_without_payment
          this.edit_bonus_payment = response.data.bonus_payment
          this.edit_pension_deduction = response.data.pension_deduction || ''
          this.edit_meals_payment = response.data.meals_payment

          this.tax_0_to_80_0_percent = response.data.tax_0_to_80_0_percent
          this.tax_80_to_250_4_percent = response.data.tax_80_to_250_4_percent
          this.tax_250_to_450_8_percent = response.data.tax_250_to_450_8_percent
          this.tax_greater_450_10_percent =
            response.data.tax_greater_450_10_percent
          this.total_tax = response.data.total_tax
          this.contribution_5_percent = response.data.contribution_5_percent

          this.tax_0_to_80_0_percent_with_health_insurance =
            response.data.tax_0_to_80_0_percent_with_health_insurance
          this.tax_80_to_250_4_percent_with_health_insurance =
            response.data.tax_80_to_250_4_percent_with_health_insurance
          this.tax_250_to_450_8_percent_with_health_insurance =
            response.data.tax_250_to_450_8_percent_with_health_insurance
          this.tax_greater_450_10_percent_with_health_insurance =
            response.data.tax_greater_450_10_percent_with_health_insurance
          this.total_tax_with_health_insurance =
            response.data.total_tax_with_health_insurance
          this.contribution_5_percent_with_health_insurance =
            response.data.contribution_5_percent_with_health_insurance

          this.net_salary = response.data.net_salary
          this.gross_salary = response.data.gross_salary

          this.edit_health_insurance_cost = response.data.health_insurance_cost
          this.edit_health_insuranace_gross =
            response.data.health_insurance_gross

          this.work_hour_per_month = parseFloat(
            response.data.work_hour_per_month
          )

          if (parseFloat(response.data.working_hours) > 0) {
            this.workinghours = true
          } else {
            this.workinghours = false
          }

          this.price_per_hours = parseFloat(response.data.price_per_hours)
          this.working_hours = parseFloat(response.data.working_hours)
          this.gross_salary_by_hours = parseFloat(
            response.data.gross_salary_by_hours
          )

          this.overtime_nightshift = response.data.overtime_nightshift
          if (
            parseFloat(this.overtime_nightshift) > 0 &&
            this.working_hours > 0
          ) {
            const percentageToAdd = parseFloat(this.setting_overtime)
            const total =
              parseFloat(this.overtime_nightshift) * this.price_per_hours
            const amountToAdd = (percentageToAdd / 100) * total
            this.p_overtime_nightshift =
              parseFloat(amountToAdd) + parseFloat(total)
            this.p_overtime_nightshift = this.p_overtime_nightshift.toFixed(2)
            this.gross_salary_by_hours =
              parseFloat(this.gross_salary_by_hours) -
              parseFloat(this.p_overtime_nightshift)
          } else {
            this.overtime_nightshift = 0
            this.p_overtime_nightshift = 0
          }

          this.wardship = response.data.wardship
          if (parseFloat(this.wardship) > 0 && this.working_hours > 0) {
            const percentageToAdd = parseFloat(this.setting_wardship)
            const total = parseFloat(this.wardship) * this.price_per_hours
            const amountToAdd = (percentageToAdd / 100) * total
            this.p_wardship = parseFloat(amountToAdd) + parseFloat(total)
            this.p_wardship = this.p_wardship.toFixed(2)
            this.gross_salary_by_hours =
              parseFloat(this.gross_salary_by_hours) -
              parseFloat(this.p_wardship)
          } else {
            this.wardship = 0
            this.p_wardship = 0
          }

          this.weekend_holidays = response.data.weekend_holidays
          if (parseFloat(this.weekend_holidays) > 0 && this.working_hours > 0) {
            const percentageToAdd = parseFloat(this.setting_weekend_holidays)
            const total =
              parseFloat(this.weekend_holidays) * this.price_per_hours
            const amountToAdd = (percentageToAdd / 100) * total
            this.p_weekend_holidays =
              parseFloat(amountToAdd) + parseFloat(total)
            this.p_weekend_holidays = this.p_weekend_holidays.toFixed(2)
            this.gross_salary_by_hours =
              parseFloat(this.gross_salary_by_hours) -
              parseFloat(this.p_weekend_holidays)
          } else {
            this.weekend_holidays = 0
            this.p_weekend_holidays = 0
          }

          this.payTax = response.data.pay_tax
          this.payContribution = response.data.pay_contribution

          setTimeout(() => {
            this.can_update = true
          }, 1000)
        })
    },

    cancelActions() {
      this.actions = false
    },

    openactions(id) {
      this.actionId = id
      this.actions = true
    },

    reset_search() {
      this.getAllGeneratedWages()
    },

    searchEmployeeInGeneratedWagesList(query) {
      this.getAllGeneratedWages(query)
    },

    loadAnotherPage: function (page_number_to) {
      this.component_loading = true
      this.$store
        .dispatch(
          'company_data/employee/finances/get_all_generated_company_monthly_salaries_with_page',
          page_number_to
        )
        .then(() => {
          this.component_loading = false
        })
    },

    openGenerateSalary() {
      if (!this.ensurePayrollExecutionSupported()) {
        return
      }

      this.modal = true
    },

    deleteGeneratedSalaries() {
      this.$store
        .dispatch(
          'company_data/employee/finances/delete_generated_all_monthly_salaries'
        )
        .then(() => {
          this.has_open_records = false
        })
    },

    openFilters() {
      this.filtermodal = true
    },

    fillMonthOptions(current_language) {
      this.export_language = this.export_language_options.filter(
        (opt) => opt.value == current_language
      )
      this.selected_month = []
      this.generate_wages_selected_month = []
      this.selected_monthOptions = []
      this.generate_wages_month_options = []

      switch (current_language) {
        case 'en':
          this.selected_monthOptions.push(
            {
              name: 'January',
              value: 1
            },
            {
              name: 'February',
              value: 2
            },
            {
              name: 'March',
              value: 3
            },
            {
              name: 'April',
              value: 4
            },
            {
              name: 'May',
              value: 5
            },
            {
              name: 'June',
              value: 6
            },
            {
              name: 'July',
              value: 7
            },
            {
              name: 'August',
              value: 8
            },
            {
              name: 'September',
              value: 9
            },
            {
              name: 'October',
              value: 10
            },
            {
              name: 'November',
              value: 11
            },
            {
              name: 'December',
              value: 12
            }
          )
          break
        case 'sq':
          this.selected_monthOptions.push(
            {
              name: 'Janar',
              value: 1
            },
            {
              name: 'Shkurt',
              value: 2
            },
            {
              name: 'Mars',
              value: 3
            },
            {
              name: 'Prill',
              value: 4
            },
            {
              name: 'Maj',
              value: 5
            },
            {
              name: 'Qershor',
              value: 6
            },
            {
              name: 'Korrik',
              value: 7
            },
            {
              name: 'Gusht',
              value: 8
            },
            {
              name: 'Shtator',
              value: 9
            },
            {
              name: 'Tetor',
              value: 10
            },
            {
              name: 'Nëntor',
              value: 11
            },
            {
              name: 'Dhjetor',
              value: 12
            }
          )
          break
      }

      if (!this.export_month || !this.export_month.value) {
        const currentMonth = this.getCurrentMonth() + 1
        for (const opt of this.selected_monthOptions) {
          if (opt.value == currentMonth) {
            this.export_month = opt
            break
          }
        }
      }

      this.generate_wages_month_options = [...this.selected_monthOptions]
    },

    close_wages: function () {
      this.$store
        .dispatch('company_data/employee/finances/close_all_records')
        .then(() => {
          this.clearFilters()
          this.has_open_records = false
        })
    },

    filterbymonth: function () {
      this.component_loading = true
      this.submitted = true
      this.$validator.validate().then((valid) => {
        if (valid) {
          let data = {
            month: this.selected_month.value,
            year: this.selected_year.value
          }

          this.$store
            .dispatch(
              'company_data/employee/finances/get_all_generated_company_monthly_salaries_with_filters',
              data
            )
            .then(() => {
              this.selected_month = []
              this.selected_year = []
              this.filtered = true
              this.filtermodal = false
              this.component_loading = false
            })
        } else {
          this.spinner_updating = false
        }
      })
    },

    generateAllWages: function () {
      this.submitted = true
      this.$validator.validate().then((valid) => {
        if (valid) {
          let data = {
            year: this.generate_wages_selected_year.value,
            month: this.generate_wages_selected_month.value
          }
          this.$store
            .dispatch(
              'company_data/employee/finances/generate_all_monthly_salaries',
              data
            )
            .then((response) => {
              if (
                response.status == 409 &&
                response.data &&
                response.data.requires_confirmation
              ) {
                const confirmed = window.confirm(
                  response.data.message ||
                    this.$t(
                      'payroll_currency.confirm_multiple_employee_mismatch'
                    )
                )

                if (!confirmed) {
                  this.modal = false
                  return
                }

                this.$store
                  .dispatch(
                    'company_data/employee/finances/generate_all_monthly_salaries',
                    {
                      ...data,
                      confirm_currency_mismatch: 1
                    }
                  )
                  .then((retryResponse) => {
                    if (retryResponse.status == 409) {
                      this.$toast.warning(
                        retryResponse.data.message ||
                          this.$t('wages_module-alerts.alredygenerated'),
                        'warning',
                        { timeut: 3000 }
                      )
                    } else {
                      this.$toast.success(
                        this.$t('wages_module-alerts.wagesgenerated'),
                        'Success',
                        { timeut: 3000 }
                      )
                    }
                    this.modal = false
                  })
              } else if (response.status == 409) {
                this.$toast.warning(
                  this.$t('wages_module-alerts.alredygenerated'),
                  'warning',
                  { timeut: 3000 }
                )
              } else {
                this.$toast.success(
                  this.$t('wages_module-alerts.wagesgenerated'),
                  'Success',
                  { timeut: 3000 }
                )
              }
              this.modal = false
            })
        } else {
          this.spinner_updating = false
        }
      })
    },

    clearFilters: function () {
      this.filtered = false
      this.getAllGeneratedWages()
    },

    getAllGeneratedWages(query) {
      this.component_loading = true
      this.$store
        .dispatch(
          'company_data/employee/finances/get_all_generated_company_monthly_salaries',
          { name: query }
        )
        .then(() => {
          this.component_loading = false
        })
    },

    updateGenerateWagesYearOptions() {
      const newYearOptions = this.generate_wages_year_options.map((item) => {
        return item
      })
      for (let yearOption of newYearOptions) {
        const closedRecords = this.closed_record_years[yearOption.value]
        if (!closedRecords) continue
        yearOption.$isDisabled = closedRecords.length == 12
      }
      this.generate_wages_year_options = newYearOptions
    }
  },

  created() {
    this.$store.dispatch('company_data/get_company_profile_data')
    this.getAllGeneratedWages()
    this.$store
      .dispatch('company_data/employee/finances/show_wages_settings')
      .then((response) => {
        this.setting_overtime = response.data.overtime
        this.setting_wardship = response.data.wardship
        this.setting_weekend_holidays = response.data.weekend_holidays
      })
  }
}
</script>
